// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "@/assets/styles/common.styl"
import '@/assets/styles/iconfont/iconfont.css'
import BaiduMap from 'vue-baidu-map'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import utils from '@/utils/urlGet';

Vue.prototype.$utils = utils;
Vue.prototype.$layer = layer(Vue);
Vue.config.productionTip = false
Vue.use(BaiduMap, {
  ak: 'DTM4kN4HGxrqcjHdDlyyhhYN'    //这个地方是官方提供的ak密钥
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
});


// WEBPACK FOOTER //
// ./src/main.js